<template>
  <div class="pointsMallhome border">
    <div v-if="homeData">
      <module :comData="moduleList" :homeData="homeData" />
    </div>
  </div>
</template>
<script>
import module from "./module.vue";
import sotreIntegralMixin from "@/Mixin/store_integral";
import api from "@/request/api";
export default {
  name: "lotteryPointsMall",
  mixins: [sotreIntegralMixin],
  components: {
    module,
  },
  data() {
    return {
      homeData: null,
	  img:'',
      moduleList: [
        {
          id: 1,
          moduleCode: "menus",
        },
        {
          id: 2,
          moduleCode: "banner",
        },
        {
          id: 3,
          moduleCode: "announce",
        },
        {
          id: 4,
          moduleCode: "category",
        },
        {
          id: 5,
          moduleCode: "shop",
        },
      ],
    };
  },
  // 更新
  mounted() {
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") {
		  
        window.location.reload();
      }
    });
    this.getHttp();
	// this.getConfigs();
  },
  methods: {
    async getHttp() {
      try {
        const [StoreIntegralIndex] = await Promise.all([
          this.getStoreIntegralIndex(),
        ]);
        if (StoreIntegralIndex.status === 200) {
          this.homeData = StoreIntegralIndex.data.data;
        }
      } catch (error) {
        console.error(error);
      }
    },
	getConfigs() {
	  try {
	    var that = this;
	    api
	      .getConfig()
	      .then((result) => {
	        if (result.status === 200) {
	          that.oss = result.data.oss.filter(
	            (item) => item.location == "#/pointsMall"
	          );
			
	          that.img = that.oss[0].img;
			 
	        } else {
	          // document.title = "云小猪-" + to.meta.web_title;
	        }
	        console.log(result);
	      })
	      .catch((err) => {
	        throw err;
	      });
	  } catch (error) {
	    console.error(error);
	  }
	},
	
  },
};
</script>
<style lang="scss" scoped>
@import "./index";
</style>
<style lang="scss">
.banner_s {
  .van-swipe__indicators {
    bottom: var(--shrink);
    .van-swipe__indicator {
      width: 0.22rem;
      height: 0.1rem;
      background-color: #c4c4c4;
      opacity: 1;
      border-radius: 0.08rem;
      margin: 0 0.08rem !important;
    }
    .van-swipe__indicator--active {
      background-color: #ffb633;
    }
  }
}
</style>
